<template>
    <b-modal
        id="personalgoal-add-tasks-modal"
        v-model="modal"
        modal-class="apprentice-default-modal personalgoal-add-tasks-modal"
        :title="$t('personal_goals.add_task')"
        header-class="personalgoal-add-tasks-modal-header"
        :ok-title="$t('common.save')"
        ok-variant="primary"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        size="md"
        @ok="onOk">
        <div class="personal-goal-add-tasks">
            <div
                class="errors"
                v-if="haserror">
                <b-alert
                    variant="danger"
                    show>
                    {{ $t('personal_goals.name_task_cannot_be_empty') }}
                </b-alert>
            </div>

            <div class="description">
                {{ $t('personal_goals.short_description_for_creating_a_personal_goal_task') }}
            </div>

            <b-form-group
                class="personal-goal-task-name-group"
                :label="$t('common.name')"
                label-for="personal-goal-task-input">
                <b-form-input
                    id="personal-goal-task-input"
                    v-model="title"
                    :placeholder="$t('personal_goals.name_task')">
                </b-form-input>
            </b-form-group>

            <b-form-group
                class="personal-goal-task-deadline-group"
                label="Deadline:"
                label-for="personal-goal-task-deadline-date">
                <b-form-datepicker
                    class="apprentice-date-picker btn-date-group"
                    id="personal-goal-task-deadline-date"
                    v-model="deadline"
                    start-weekday="1"
                    now-button
                    reset-button
                    right
                    today-variant="primary"
                    nav-button-variant="primary"
                    locale="nl"
                    :aria-controls="$t('personal_goals.choose_date')"
                    label-reset-button="reset"
                    :label-no-date-selected="$t('personal_goals.choose_date')"
                    menu-class="datedropdown"
                    :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }">
                </b-form-datepicker>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
import { ords } from '../../../app';
import Design2021ApprenticeDataTable from '../../common/design-2021-apprentice-data-table.vue';

export default {
    name: 'design-2021-personal-goal-add-task-modal-component',
    components: { Design2021ApprenticeDataTable },
    props: {},
    data() {
        return {
            modal: false,
            title: '',
            deadline: '',
            fields: [
                {
                    key: 'name',
                    label: this.$t('personal_goals.task'),
                },
                {
                    key: 'deadline',
                    label: 'Deadline',
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
            tasks: [],

            personalGoal: '',
            haserror: false,
            errors: {
                tasks: {
                    error: false,
                    message: this.$t('personal_goals.you_have_not_completed_the_description_of_one_or_more_tasks'),
                },
            },
        };
    },

    methods: {
        show(goal) {
            this.personalGoal = goal;
            this.title = '';
            this.deadline = '';
            this.modal = true;
        },

        onOk(bvModalEvt) {
            if (!this.isTaskValidated()) {
                this.haserror = true;
                bvModalEvt.preventDefault();
                return;
            }

            const data = {
                task_name: this.title,
            };

            if (this.deadline !== '') {
                data.task_deadline = this.deadline;
            }

            this.alert.saving();
            this.axios.post(this.routes.personalGoalTaskAdd(this.personalGoal.id), data).then(
                (response) => {
                    ords.hold();
                    this.personalGoal.addRelation('tasks', response.data);
                    ords.continue();

                    this.alert.success();

                    this.$emit('task-added', response.data);
                },

                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        removePersonalGoalTask(row) {
            this.tasks = this.tasks.filter((task, index) => index !== row.index);
        },

        addTask() {
            if (this.isTaskTitleEmpty()) {
                this.haserror = true;
                return;
            }

            this.tasks.push({
                name: this.title,
                personal_goal_id: this.personalGoal.id,
                user_id: this.$authUser.id,
                deadline: this.deadline,
            });

            this.title = '';
            this.deadline = '';
        },

        isTaskValidated() {
            this.haserror = false;

            return this.title !== '' && this.title !== null;
        },
    },
};
</script>

<style scoped lang="scss">
.description {
    color: $text-muted-color;
    font-weight: $font-weight-medium;
    line-height: 1.5;
    margin-bottom: $grid-gutter-width;
}

.personal-goal-task-group ::v-deep {
    margin-bottom: $grid-gutter-width;

    .input-group-prepend,
    .input-group-append {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-items: baseline;

        > label {
            flex: 1 0 100%;
            margin-bottom: 4px;
        }

        input,
        .btn-date-group {
            margin-bottom: 0;
        }
    }

    .input-group-prepend {
        flex: 1 0 65%;

        input {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }
    }

    .input-group-append {
        flex: 1 0 35%;

        > .btn-date-group {
            flex: 1;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;

            > button {
                background: $primary;
                border-radius: 0;

                &:before {
                    color: $white;
                }
            }
        }

        .btn-new-task {
            margin-left: $grid-gutter-width;
            height: 51px;
            border-radius: map-get($grid-gutter-spacing, 'eight');

            &:before {
                margin-right: 0;
                font-size: 1.25rem;
                line-height: 1;
            }
        }
    }
}
</style>
